import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import { FilterButton } from 'components/atoms/filtersButton';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
import { CallToAction } from 'components/atoms/callToAction';
//eslint-disable-next-line
import styles from "./styles.scss";

const PastEventsMobile = props => {
  const { height } = useViewport();
  const {
    filteredEvents,
    isFiltered,
    activeFilters,
    pastEventsIntro,
    pastEvents,
    type,
    cmsDetailData = {},
    showCmsButton,
    hasMore,
    loadingMore,
    pagination,
    activeFilterIds,
    getPastEvents,
  } = props;

  const handleSlideChange = nextIndex => {
    const eventsData = isFiltered ? filteredEvents : pastEvents;
    if (nextIndex >= eventsData.length - 2 && hasMore && !loadingMore) {
      getPastEvents(pagination.page + 1, 25, {
        venueIds: (activeFilterIds && activeFilterIds.venue) || [],
        cityIds: (activeFilterIds && activeFilterIds.city) || [],
        genreIds: (activeFilterIds && activeFilterIds.genre) || [],
        artistIds: (activeFilterIds && activeFilterIds.artist) || [],
      });
    }
  };

  const [showFullBioOverlay, setShowFullBioOverlay] = useState(false);

  const toggleFullBioOverlay = showFullBioOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={cmsDetailData}
        theme={'light-theme'}
        type={'description-overlay'}
        onClosePress={() => setShowFullBioOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Music & Events',
            breadcrumbLink: RouteNames.musicEvents,
          },
          {
            breadcrumbName: 'Artist Details',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div
      className={
        type === 'artist'
          ? 'artist-events-mobile past-events-mobile'
          : 'past-events-mobile'
      }
      style={{ height }}
    >
      {type !== 'artist' && (
        <FilterButton
          className={`project-filter-mobile ${
            activeFilters.length > 0 ? 'highlight' : ''
          }`}
          filterType={'past-events-mobile'}
          theme={'dark-theme'}
          isMobile={true}
          activeFilters={activeFilters}
          filterContent={[]}
        />
      )}
      <div className={'inner-container'}>
        <div
          className={
            type === 'artist'
              ? 'section-intro artist-container'
              : 'section-intro'
          }
        >
          <h2 className={'section-heading'}>{pastEventsIntro.headingMobile}</h2>
          {type === 'artist' && (
            <h2 className={'section-heading'}>{pastEventsIntro.subHeading}</h2>
          )}
          <p
            className={
              type === 'artist'
                ? 'section-description artist-description'
                : 'section-description'
            }
          >
            {pastEventsIntro.paragraphMobile}
          </p>
          {type === 'artist' && showCmsButton && (
            <div className={'open-overlay'}>
              <CallToAction
                mode={'light'}
                className={'button-item'}
                text={'FULL BIO'}
                onClick={() => setShowFullBioOverlay(true)}
              />
            </div>
          )}
        </div>
        {isFiltered && pastEvents && pastEvents.length === 0 ? (
          <div className={'no-events-found'}>
            <h2 className={'no-events-title'}>No Events Found</h2>
            <p className={'no-events-subtitle'}>Try adjusting your filters to discover more events.</p>
          </div>
        ) : pastEvents && pastEvents.length > 0 ? (
          <HorizontalCarousel
            data={isFiltered ? filteredEvents : pastEvents && pastEvents}
            cssFor={'horizontal-carousel-container'}
            type={'past-events-mobile'}
            name={type}
            getActiveSlide={handleSlideChange}
          />
        ) : (
          <div className={'artist-card-image'}>
            <img src={pastEventsIntro.artist_image} alt={'artist-image'} />
          </div>
        )}
      </div>
      {toggleFullBioOverlay}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isFiltered: EventSelector.isEventsFiltered(state, 'past'),
    activeFilters: EventSelector.getActiveEventFiltersNames(state),
    filteredEvents: EventSelector.getFilteredEvents(state, 'past'),
    hasMore: EventSelector.hasMorePastEvents(state),
    loadingMore: EventSelector.getPastEventsLoadingMore(state),
    pagination: EventSelector.getPastEventsPagination(state),
    activeFilterIds: EventSelector.getActiveEventFilters(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getPastEvents } = EventActions;
  return bindActionCreators({ getPastEvents }, dispatch);
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PastEventsMobile);

export default withRouter(connectedComponent);
